
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Vision Mission</h1>
                </div>
            </div>
        </div>			
    </div>	
</section>  

<section class="section-lg ">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="main-timeline">
                    <div class="timeline" >
                        <div class="timeline-content" >
                            <div class="timeline-icon"><i class="fa fa-eye" aria-hidden="true"></i></div>
                            <div class="inner-title"  >
                                <h3 class="text-left">Vision</h3>
                               
                            </div>
                            <p>
                                To achieve excellent standards of quality education by keeping pace with rapidly changing technologies and to create technical manpower of global standards with capabilities of accepting new challenges.
                            </p>
                        </div>
                    </div>
                    <div class="timeline" >
                        <div class="timeline-content">
                            <div class="timeline-icon"><i class="fa fa-rocket"></i></div>
                            <div class="inner-title"  >
                                <h3 class="text-left">Mission</h3>
                               
                            </div>
                            <ul class="list-item">
                                <li>Our efforts are dedicated to impart quality and value based education to raise satisfaction level of all stakeholders.</li>
                                <li>Our Strength is directed to create competent professionals.</li>
                                <li>Our endeavor is to provide all possible support to<br> promote research and development activities.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

